import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';

const newGenericGrid = new GenericGridCreator(
  'REVIEW_IMPACT',
  {},
  {
    addedFilters: [],
    orderBy: [],
    hiddenTerms: [],
    tableProps: {
      useSelectAll: false
    }
  },
  {
    getInstanceState: store => store.reviewGeoDifferential.reviewImpactGridReducer
  }
);
export const reviewImpactGridActions = newGenericGrid.getActions();

export default newGenericGrid.createReducer();
